"use client";

import Image from "next/image";
import Link from "next/link";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { GithubIcon, GlobeIcon, GraduationCap, Linkedin, TwitterIcon } from "lucide-react";

interface Person {
  name: string;
  image: string;
  link: string;
  title: string;
  designation: string;
  linkedIn?: string;
  twitter?: string;
  github?: string;
  personalWebsite?: string;
  googleScholar?: string;
}

interface PeopleCardProps {
  person: Person;
  featured?: boolean;
}

export default function PeopleCard({ person, featured = false }: PeopleCardProps) {
  return (
    <div className="group cursor-default">

      <Card className={`overflow-hidden hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1 ${
        featured ? 'max-w-sm mx-auto' : ''
      }`}>
        <div
  className={`relative overflow-hidden rounded-lg ${
    featured ? 'aspect-[4/5]' : 'aspect-square'
  } m-4`}
>
  <div className="relative flex justify-center pt-6">
  <div className="relative w-100 h-100 rounded-lg overflow-hidden">
    <Image
      src={person.image}
      alt={person.name}
      fill
      className="object-cover transition-transform duration-300 group-hover:scale-105"
      onError={(e) => {
        e.currentTarget.src = '/images/placeholder-avatar.svg';
      }}
    />
  </div>
</div>
</div>

          <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"></div>
        
        
        <CardHeader className={featured ? 'text-center' : ''}>
          <CardTitle className={`group-hover:text-primary transition-colors duration-200 ${
            featured ? 'text-2xl' : 'text-lg'
          }`}>
            {person.name}
          </CardTitle>
          
          <p className={`text-primary font-semibold ${
            featured ? 'text-lg' : 'text-sm'
          }`}>
            {person.title}
          </p>
        </CardHeader>
        
        <CardContent className={featured ? 'text-center' : ''}>
          <p className={`text-gray-600 leading-relaxed ${
            featured ? 'text-base' : 'text-sm'
          }`}>
            {person.designation}
          </p>
        </CardContent>
        <CardFooter className="flex justify-center space-x-4 mt-4">
  {person.linkedIn && (
    <a href={person.linkedIn} target="_blank" rel="noopener noreferrer">
      <Linkedin className="text-primary hover:scale-110" size={24} />
    </a>
  )}

  {person.twitter && (
    <a href={person.twitter} target="_blank" rel="noopener noreferrer">
      <TwitterIcon className="text-primary hover:scale-110" size={24} />
    </a>
  )}

  {person.github && (
    <a href={person.github} target="_blank" rel="noopener noreferrer">
      <GithubIcon className="text-primary hover:scale-110" size={24} />
    </a>
  )}

  {person.personalWebsite && (
    <a href={person.personalWebsite} target="_blank" rel="noopener noreferrer">
      <GlobeIcon className="text-primary hover:scale-110" size={24} />
    </a>
  )}

  {person.googleScholar && (
    <a href={person.googleScholar} target="_blank" rel="noopener noreferrer">
      <GraduationCap className="text-primary hover:scale-110" size={24} />
    </a>
  )}
</CardFooter>

      </Card>
    </div>
  );
}
